(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-collection-grid"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Reveal the sticky min-order sidebar only once the banner panel scrolls out of view.
  (function () {
    function initMinOrderReveal() {
      const sidebar = document.querySelector('.wholesale-grid__minorder');
      if (!sidebar) return;

      const banner = document.querySelector('.b2b-min-order--banner');
      if (!banner || !('IntersectionObserver' in window)) {
        sidebar.classList.remove('is-hidden');
        return;
      }

      sidebar.classList.add('is-hidden');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            sidebar.classList.toggle('is-hidden', entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      observer.observe(banner);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMinOrderReveal, { once: true });
    } else {
      initMinOrderReveal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-gate"] && !Shopify.designMode) return;
  try {
    
  const SHADOW_FIELD_MAP = {
    company_name: ['#company_name'],
    email: ['#email'],
    phone_number: ['#phone_number'],
    country: ['#custom\\#country_', '[id="custom#country_"]'],
    billing_address1: [
      '#address1',
      '[id="address1"]',
      '#address_1',
      '[id="address_1"]',
      '#billing_address_address1',
      '[id="billing_address_address1"]',
      '#company_location_address1',
      '[id="company_location_address1"]',
      'input[name="address1"]',
      'input[name="address_1"]',
      'input[name="billing_address[address1]"]',
      'input[data-testid="field-billing_address_address1"]',
      'input[data-testid="field-address1"]',
      'input[data-testid="field-address_1"]',
      '#custom\\#address1',
      '[id="custom#address1"]',
      '#custom\\#address_line_1',
      '[id="custom#address_line_1"]'
    ],
    shipping_address1: [
      '#shipping_address_address1',
      '[id="shipping_address_address1"]',
      'input[name="shipping_address[address1]"]',
      'input[data-testid="field-shipping_address_address1"]'
    ],
    billing_address2: [
      '#address2',
      '[id="address2"]',
      '#address_2',
      '[id="address_2"]',
      '#billing_address_address2',
      '[id="billing_address_address2"]',
      '#company_location_address2',
      '[id="company_location_address2"]',
      'input[name="address2"]',
      'input[name="address_2"]',
      'input[name="billing_address[address2]"]',
      'input[data-testid="field-billing_address_address2"]',
      'input[data-testid="field-address2"]',
      'input[data-testid="field-address_2"]',
      '#custom\\#address2',
      '[id="custom#address2"]',
      '#custom\\#address_line_2',
      '[id="custom#address_line_2"]'
    ],
    shipping_address2: [
      '#shipping_address_address2',
      '[id="shipping_address_address2"]',
      'input[name="shipping_address[address2]"]',
      'input[data-testid="field-shipping_address_address2"]'
    ],
    billing_city: [
      '#city',
      '[id="city"]',
      '#billing_address_city',
      '[id="billing_address_city"]',
      '#company_location_city',
      '[id="company_location_city"]',
      'input[name="city"]',
      'input[name="billing_address[city]"]',
      'input[data-testid="field-billing_address_city"]',
      'input[data-testid="field-city"]',
      '#custom\\#city',
      '[id="custom#city"]'
    ],
    shipping_city: [
      '#shipping_address_city',
      '[id="shipping_address_city"]',
      'input[name="shipping_address[city]"]',
      'input[data-testid="field-shipping_address_city"]'
    ],
    billing_province: [
      '#province',
      '[id="province"]',
      '#state',
      '[id="state"]',
      '#province_code',
      '[id="province_code"]',
      '#billing_address_province',
      '[id="billing_address_province"]',
      '#billing_address_province_code',
      '[id="billing_address_province_code"]',
      '#billing_address_state',
      '[id="billing_address_state"]',
      '#company_location_province',
      '[id="company_location_province"]',
      'input[name="province"]',
      'input[name="province_code"]',
      'input[name="state"]',
      'input[name="billing_address[province]"]',
      'input[name="billing_address[province_code]"]',
      'input[name="billing_address[state]"]',
      'input[data-testid="field-billing_address_province"]',
      'input[data-testid="field-billing_address_state"]',
      'input[data-testid="field-province"]',
      'input[data-testid="field-state"]',
      'select[name="billing_address[province]"]',
      'select[name="billing_address[province_code]"]',
      'select[name="province"]',
      'select[name="province_code"]',
      '#custom\\#province',
      '[id="custom#province"]',
      '#custom\\#state',
      '[id="custom#state"]'
    ],
    shipping_province: [
      '#shipping_address_province',
      '[id="shipping_address_province"]',
      '#shipping_address_province_code',
      '[id="shipping_address_province_code"]',
      'input[name="shipping_address[province]"]',
      'input[name="shipping_address[province_code]"]',
      'input[data-testid="field-shipping_address_province"]',
      'input[data-testid="field-shipping_address_state"]',
      'select[name="shipping_address[province]"]',
      'select[name="shipping_address[province_code]"]'
    ],
    billing_zip: [
      '#zip',
      '[id="zip"]',
      '#postal_code',
      '[id="postal_code"]',
      '#billing_address_zip',
      '[id="billing_address_zip"]',
      '#company_location_zip',
      '[id="company_location_zip"]',
      'input[name="zip"]',
      'input[name="postal_code"]',
      'input[name="billing_address[zip]"]',
      'input[data-testid="field-billing_address_zip"]',
      'input[data-testid="field-zip"]',
      'input[data-testid="field-postal_code"]',
      '#custom\\#zip',
      '[id="custom#zip"]',
      '#custom\\#postal_code',
      '[id="custom#postal_code"]'
    ],
    shipping_zip: [
      '#shipping_address_zip',
      '[id="shipping_address_zip"]',
      'input[name="shipping_address[zip]"]',
      'input[data-testid="field-shipping_address_zip"]'
    ],
    social_media: [
      '#custom\\#social_media_',
      '[id="custom#social_media_"]',
      '#custom\\#social_media',
      '[id="custom#social_media"]',
      'input[name="custom#social_media_"]',
      'input[name="custom#social_media"]',
      'input[data-testid="field-custom#social_media_"]',
      'input[data-testid="field-custom#social_media"]'
    ],
    website: ['#custom\\#website_', '[id="custom#website_"]'],
    tax: ['#custom\\#tax_vat_business_registration_number', '[id="custom#tax_vat_business_registration_number"]', 'input[data-testid="field-custom#tax_vat_business_registration_number"]'],
    store_details: [
      '#custom\\#store_details_',
      '[id="custom#store_details_"]',
      '#custom\\#store_details',
      '[id="custom#store_details"]',
      'textarea[name="custom#store_details_"]',
      'textarea[name="custom#store_details"]',
      'textarea[data-testid="field-custom#store_details_"]',
      'textarea[data-testid="field-custom#store_details"]',
      'textarea[data-testid^="field-custom"]',
      'textarea[class*="_textArea_"]'
    ],
    business_type: [
      '#custom\\#business_type',
      '[id="custom#business_type"]',
      'input[name="custom#business_type"]',
      'input[data-testid="field-custom#business_type"]'
    ]
  };

  const SHADOW_DROPDOWN_KEYS = {
    business_type: ['custom#business_type', 'business_type'],
    billing_province: [
      'billing_address_province',
      'billing_address_state',
      'billing_address_zone'
    ],
    shipping_province: [
      'shipping_address_province',
      'shipping_address_state',
      'shipping_address_zone'
    ]
  };

  const SHADOW_LABEL_FALLBACKS = {
    store_details: 'store details',
    country: 'country',
    billing_address1: 'billing address',
    billing_address2: 'billing address line 2',
    billing_city: 'billing city',
    billing_province: 'billing state',
    billing_zip: 'billing postal',
    shipping_address1: 'shipping address',
    shipping_address2: 'shipping address line 2',
    shipping_city: 'shipping city',
    shipping_province: 'shipping state',
    shipping_zip: 'shipping postal',
    social_media: 'social media',
    business_type: 'business type'
  };

  // International dialling codes keyed by Shopify's country values
  // (`all_country_option_tags`). Used to build an E.164-style number when the
  // visitor types a national number without a leading "+", so the hidden
  // Shopify Forms phone field can auto-detect the country and validate.
  const COUNTRY_DIAL_CODES = {
    Afghanistan: '93', 'Aland Islands': '358', Albania: '355', Algeria: '213',
    Andorra: '376', Angola: '244', Anguilla: '1', 'Antigua And Barbuda': '1',
    Argentina: '54', Armenia: '374', Aruba: '297', 'Ascension Island': '247',
    Australia: '61', Austria: '43', Azerbaijan: '994', Bahamas: '1',
    Bahrain: '973', Bangladesh: '880', Barbados: '1', Belarus: '375',
    Belgium: '32', Belize: '501', Benin: '229', Bermuda: '1', Bhutan: '975',
    Bolivia: '591', 'Bosnia And Herzegovina': '387', Botswana: '267',
    Brazil: '55', 'British Indian Ocean Territory': '246',
    'Virgin Islands, British': '1', Brunei: '673', Bulgaria: '359',
    'Burkina Faso': '226', Burundi: '257', Cambodia: '855',
    'Republic of Cameroon': '237', Canada: '1', 'Cape Verde': '238',
    'Caribbean Netherlands': '599', 'Cayman Islands': '1',
    'Central African Republic': '236', Chad: '235', Chile: '56', China: '86',
    'Christmas Island': '61', 'Cocos (Keeling) Islands': '61', Colombia: '57',
    Comoros: '269', Congo: '242', 'Congo, The Democratic Republic Of The': '243',
    'Cook Islands': '682', 'Costa Rica': '506', Croatia: '385', 'Curaçao': '599',
    Cyprus: '357', 'Czech Republic': '420', "Côte d'Ivoire": '225',
    Denmark: '45', Djibouti: '253', Dominica: '1', 'Dominican Republic': '1',
    Ecuador: '593', Egypt: '20', 'El Salvador': '503', 'Equatorial Guinea': '240',
    Eritrea: '291', Estonia: '372', Eswatini: '268', Ethiopia: '251',
    'Falkland Islands (Malvinas)': '500', 'Faroe Islands': '298', Fiji: '679',
    Finland: '358', France: '33', 'French Guiana': '594', 'French Polynesia': '689',
    'French Southern Territories': '262', Gabon: '241', Gambia: '220',
    Georgia: '995', Germany: '49', Ghana: '233', Gibraltar: '350', Greece: '30',
    Greenland: '299', Grenada: '1', Guadeloupe: '590', Guatemala: '502',
    Guernsey: '44', Guinea: '224', 'Guinea Bissau': '245', Guyana: '592',
    Haiti: '509', Honduras: '504', 'Hong Kong': '852', Hungary: '36',
    Iceland: '354', India: '91', Indonesia: '62', Iraq: '964', Ireland: '353',
    'Isle Of Man': '44', Israel: '972', Italy: '39', Jamaica: '1', Japan: '81',
    Jersey: '44', Jordan: '962', Kazakhstan: '7', Kenya: '254', Kiribati: '686',
    Kosovo: '383', Kuwait: '965', Kyrgyzstan: '996',
    "Lao People's Democratic Republic": '856', Latvia: '371', Lebanon: '961',
    Lesotho: '266', Liberia: '231', 'Libyan Arab Jamahiriya': '218',
    Liechtenstein: '423', Lithuania: '370', Luxembourg: '352', Macao: '853',
    Madagascar: '261', Malawi: '265', Malaysia: '60', Maldives: '960', Mali: '223',
    Malta: '356', Martinique: '596', Mauritania: '222', Mauritius: '230',
    Mayotte: '262', Mexico: '52', 'Moldova, Republic of': '373', Monaco: '377',
    Mongolia: '976', Montenegro: '382', Montserrat: '1', Morocco: '212',
    Mozambique: '258', Myanmar: '95', Namibia: '264', Nauru: '674', Nepal: '977',
    Netherlands: '31', 'New Caledonia': '687', 'New Zealand': '64',
    Nicaragua: '505', Niger: '227', Nigeria: '234', Niue: '683',
    'Norfolk Island': '672', 'North Macedonia': '389', Norway: '47', Oman: '968',
    Pakistan: '92', 'Palestinian Territory, Occupied': '970', Panama: '507',
    'Papua New Guinea': '675', Paraguay: '595', Peru: '51', Philippines: '63',
    Pitcairn: '64', Poland: '48', Portugal: '351', Qatar: '974', Reunion: '262',
    Romania: '40', Russia: '7', Rwanda: '250', Samoa: '685', 'San Marino': '378',
    'Sao Tome And Principe': '239', 'Saudi Arabia': '966', Senegal: '221',
    Serbia: '381', Seychelles: '248', 'Sierra Leone': '232', Singapore: '65',
    'Sint Maarten': '1', Slovakia: '421', Slovenia: '386', 'Solomon Islands': '677',
    Somalia: '252', 'South Africa': '27',
    'South Georgia And The South Sandwich Islands': '500', 'South Korea': '82',
    'South Sudan': '211', Spain: '34', 'Sri Lanka': '94', 'Saint Barthélemy': '590',
    'Saint Helena': '290', 'Saint Kitts And Nevis': '1', 'Saint Lucia': '1',
    'Saint Martin': '590', 'Saint Pierre And Miquelon': '508', 'St. Vincent': '1',
    Sudan: '249', Suriname: '597', 'Svalbard And Jan Mayen': '47', Sweden: '46',
    Switzerland: '41', Taiwan: '886', Tajikistan: '992',
    'Tanzania, United Republic Of': '255', Thailand: '66', 'Timor Leste': '670',
    Togo: '228', Tokelau: '690', Tonga: '676', 'Trinidad and Tobago': '1',
    'Tristan da Cunha': '290', Tunisia: '216', Turkey: '90', Turkmenistan: '993',
    'Turks and Caicos Islands': '1', Tuvalu: '688',
    'United States Minor Outlying Islands': '1', Uganda: '256', Ukraine: '380',
    'United Arab Emirates': '971', 'United Kingdom': '44', 'United States': '1',
    Uruguay: '598', Uzbekistan: '998', Vanuatu: '678',
    'Holy See (Vatican City State)': '39', Venezuela: '58', Vietnam: '84',
    'Wallis And Futuna': '681', 'Western Sahara': '212', Yemen: '967',
    Zambia: '260', Zimbabwe: '263'
  };

  const normalizeFieldText = (text) => (text ?? '').replace(/\s+/g, ' ').trim().toLowerCase();

  const optionMatchesValue = (optionText, value) => {
    const option = normalizeFieldText(optionText);
    const target = normalizeFieldText(value);
    if (!option || !target) return false;
    return option === target || option.includes(target) || target.includes(option);
  };

  const SUCCESS_STEPS = new Set(['success', 'thank-you', 'thank_you', 'complete', 'submitted']);

  const activateWholesaleGateTab = (gate, tab) => {
    const tabName = tab.dataset.wholesaleGateTab;

    gate.querySelectorAll('[data-wholesale-gate-tab]').forEach((button) => {
      const active = button === tab;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });

    gate.querySelectorAll('[data-wholesale-gate-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.wholesaleGatePanel !== tabName;
    });
  };

  const getShadowRoot = (formId, gate) => {
    const mount = gate?.querySelector('[data-wholesale-gate-forms-mount]');
    if (!mount) return null;
    const embed = mount.querySelector('.shopify-app-block shopify-forms-embed') ?? mount.querySelector('shopify-forms-embed');
    return embed?.shadowRoot ?? null;
  };

  const waitForShadowForm = (formId, gate, timeout = 15000) => new Promise((resolve, reject) => {
    const started = Date.now();
    const mount = gate?.querySelector('[data-wholesale-gate-forms-mount]');

    const tryResolve = () => {
      const shadow = getShadowRoot(formId, gate);
      if (shadow?.querySelector('#company_name')) {
        resolve(shadow);
        return true;
      }
      return false;
    };

    if (tryResolve()) return;

    const observer = mount ? new MutationObserver(() => {
      if (tryResolve()) observer.disconnect();
    }) : null;

    if (observer && mount) {
      observer.observe(mount, { childList: true, subtree: true });
    }

    const poll = () => {
      if (tryResolve()) {
        observer?.disconnect();
        return;
      }

      if (Date.now() - started > timeout) {
        observer?.disconnect();
        reject(new Error('timeout'));
        return;
      }

      requestAnimationFrame(poll);
    };

    poll();
  });

  // Shopify Forms inputs are React-controlled — assigning `.value` directly is
  // ignored on re-render. Use the prototype's native setter so React's internal
  // tracker registers the change (critical for the phone component).
  const setNativeValue = (input, value) => {
    const proto = input instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : input instanceof HTMLSelectElement
        ? HTMLSelectElement.prototype
      : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, value);
    } else {
      input.value = value;
    }
  };

  const setNativeChecked = (input, checked) => {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, checked);
    } else {
      input.checked = checked;
    }
  };

  const dispatchInputEvents = (input) => {
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new FocusEvent('focus', { bubbles: true }));
    input.dispatchEvent(new FocusEvent('blur', { bubbles: true }));
  };

  // The Shopify Forms phone field is a masked, keystroke-driven input: assigning
  // `.value` (even via the native setter) is reverted to the country prefix on the
  // next render. It does, however, honour a real paste event — it parses the
  // pasted number, auto-selects the country from the leading "+" dial code, and
  // formats/validates it. So we drive it by dispatching a ClipboardEvent.
  const pasteIntoInput = (input, value) => {
    input.focus();
    try {
      input.setSelectionRange(0, input.value.length);
    } catch (error) {
      /* some input types don't support selection — paste still replaces */
    }

    const data = new DataTransfer();
    data.setData('text/plain', value);
    const pasted = input.dispatchEvent(new ClipboardEvent('paste', {
      clipboardData: data,
      bubbles: true,
      cancelable: true,
      composed: true
    }));

    input.dispatchEvent(new FocusEvent('blur', { bubbles: true }));
    return pasted;
  };

  // Normalise a phone number to international format so the country auto-detects.
  // Leaves already-international numbers ("+…" or "00…") untouched; otherwise
  // prepends the selected country's dial code and drops the national trunk "0".
  const toInternationalPhone = (rawValue, countryValue) => {
    const value = (rawValue ?? '').trim();
    if (!value) return value;
    if (value.startsWith('+')) return value;
    if (value.startsWith('00')) return `+${value.slice(2).trim()}`;

    const dialCode = COUNTRY_DIAL_CODES[countryValue];
    if (!dialCode) return value;

    const national = value.replace(/\D/g, '').replace(/^0+/, '');
    if (!national) return value;
    return `+${dialCode}${national}`;
  };

  const findShadowField = (shadow, selectors) => {
    for (const selector of selectors) {
      const field = shadow.querySelector(selector);
      if (field) return field;
    }
    return null;
  };

  const findShadowFieldByLabel = (shadow, labelNeedle) => {
    const needle = normalizeFieldText(labelNeedle);
    const labelNodes = shadow.querySelectorAll('label, p[class*="_label_"]');

    for (const labelNode of labelNodes) {
      const text = normalizeFieldText(labelNode.textContent);
      if (!text.includes(needle)) continue;

      // Shopify Forms labels often have a self-referential `for` (for == label id)
      // or `for="label-<id>"`. Strip the `label-` prefix and ignore matches that
      // resolve back to a <label> (i.e. the label itself), which has no value.
      const rawId = labelNode.getAttribute('for') || labelNode.id || '';
      const controlId = rawId.replace(/^label-/, '');
      if (controlId) {
        const byId = shadow.getElementById(controlId) ?? shadow.querySelector(`[id="${CSS.escape(controlId)}"]`);
        if (byId && byId !== labelNode && byId.tagName !== 'LABEL') return byId;
      }

      const container = labelNode.closest('[class*="_formFieldContainer_"], [class*="_selectContainer_"]');
      const field = container?.querySelector('input, textarea, select, button[aria-controls]');
      if (field) return field;
    }

    return null;
  };

  const setShadowInput = (shadow, selectors, value, labelFallback) => {
    if (value == null || value === '') return true;

    let input = findShadowField(shadow, selectors);
    if (!input && labelFallback) {
      input = findShadowFieldByLabel(shadow, labelFallback);
    }
    if (!input) return false;

    if ('value' in input) {
      setNativeValue(input, value);
      dispatchInputEvents(input);
      return true;
    }

    return false;
  };

  const setShadowCheckbox = (shadow, selectors, checked) => {
    const input = findShadowField(shadow, selectors);
    if (!input || input.type !== 'checkbox') return false;
    if (input.checked !== checked) {
      setNativeChecked(input, checked);
      dispatchInputEvents(input);
    }
    return true;
  };

  const splitName = (fullName) => {
    const trimmed = fullName.trim();
    const spaceIndex = trimmed.indexOf(' ');

    if (spaceIndex === -1) {
      return { first: trimmed, last: trimmed };
    }

    const first = trimmed.slice(0, spaceIndex);
    const last = trimmed.slice(spaceIndex + 1).trim() || first;
    return { first, last };
  };

  const waitFor = (test, timeout = 800) => new Promise((resolve) => {
    const started = Date.now();
    const tick = () => {
      const result = test();
      if (result) {
        resolve(result);
        return;
      }
      if (Date.now() - started > timeout) {
        resolve(null);
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });

  const findDropdownToggle = (shadow, fieldKeys, labelFallback) => {
    const keys = Array.isArray(fieldKeys) ? fieldKeys : [fieldKeys];

    for (const key of keys) {
      const toggles = shadow.querySelectorAll(`button[aria-controls*="${key}"]`);
      for (const toggle of toggles) {
        if (toggle.hasAttribute('aria-controls')) return toggle;
      }
    }

    return labelFallback ? findShadowFieldByLabel(shadow, labelFallback) : null;
  };

  const collectDropdownOptions = (shadow, toggle) => {
    const dropdownId = toggle.getAttribute('aria-controls');
    const scopes = [];

    if (dropdownId) {
      scopes.push(
        shadow.getElementById(dropdownId),
        shadow.querySelector(`[id="${CSS.escape(dropdownId)}"]`)
      );
    }

    scopes.push(
      shadow.querySelector('[role="listbox"]'),
      shadow.querySelector('[role="menu"]'),
      shadow
    );

    const options = [];
    for (const scope of scopes) {
      if (!scope) continue;
      scope.querySelectorAll('[role="option"], [role="menuitem"], li, button').forEach((node) => {
        if (node === toggle) return;
        if (node.matches('[data-testid="btn-form-submit"]')) return;
        const text = node.textContent?.trim();
        if (text) options.push(node);
      });
    }

    return [...new Set(options)];
  };

  const setDropdownToggleValue = async (shadow, toggle, value) => {
    if (!value) return false;
    if (!toggle || !toggle.hasAttribute('aria-controls')) return false;

    const pickOption = () => {
      const options = collectDropdownOptions(shadow, toggle);
      return options.find((option) => optionMatchesValue(option.textContent, value)) ?? null;
    };

    const openDropdown = async () => {
      if (toggle.getAttribute('aria-expanded') !== 'true') {
        toggle.click();
        await new Promise((resolve) => setTimeout(resolve, 120));
      }
    };

    await openDropdown();
    let option = await waitFor(pickOption, 2000);

    if (!option) {
      toggle.click();
      await new Promise((resolve) => setTimeout(resolve, 80));
      await openDropdown();
      option = await waitFor(pickOption, 2000);
    }

    if (!option) {
      if (toggle.getAttribute('aria-expanded') === 'true') toggle.click();
      return false;
    }

    option.click();
    await new Promise((resolve) => setTimeout(resolve, 80));
    return true;
  };

  const setShadowDropdown = async (shadow, fieldKeys, value, labelFallback) => {
    const toggle = findDropdownToggle(shadow, fieldKeys, labelFallback);
    return setDropdownToggleValue(shadow, toggle, value);
  };

  const settleShadowForm = () => new Promise((resolve) => {
    // requestAnimationFrame never fires while the tab is backgrounded or
    // hidden, which would otherwise hang the submit indefinitely if the
    // visitor switches away right after clicking submit. Race it against
    // a short timeout so this always settles.
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      resolve();
    };
    requestAnimationFrame(() => requestAnimationFrame(finish));
    setTimeout(finish, 300);
  });

  const showSyncError = (gate, message) => {
    const errorBox = gate.querySelector('[data-wholesale-gate-sync-error]');
    const errorText = gate.querySelector('[data-wholesale-gate-sync-error-text]');
    if (!errorBox || !errorText) return;

    errorText.textContent = message;
    errorBox.hidden = false;
    errorBox.focus();
  };

  const hideSyncError = (gate) => {
    const errorBox = gate.querySelector('[data-wholesale-gate-sync-error]');
    if (errorBox) errorBox.hidden = true;
  };

  const showSuccess = (gate) => {
    const form = gate.querySelector('[data-wholesale-gate-form]');
    const success = gate.querySelector('[data-wholesale-gate-success]');
    if (form) form.hidden = true;
    if (success) {
      success.hidden = false;
      success.focus();
    }
  };

  const setSubmitting = (gate, isSubmitting) => {
    const button = gate.querySelector('[data-wholesale-gate-submit]');
    if (!button) return;

    button.disabled = isSubmitting;
    button.setAttribute('aria-busy', String(isSubmitting));
  };

  const getShadowValidationErrors = (shadow) => {
    const invalidFields = shadow.querySelectorAll('[aria-invalid="true"]');
    const messages = [];

    invalidFields.forEach((field) => {
      const label = field.getAttribute('aria-labelledby');
      const labelNode = label ? shadow.getElementById(label) : null;
      const name = labelNode?.textContent?.trim() || field.getAttribute('aria-label') || field.id;
      if (name) messages.push(name);
    });

    return messages;
  };

  const watchForSuccess = (shadow) => new Promise((resolve) => {
    const appEmbed = shadow.querySelector('#app-embed');
    const shadowForm = shadow.querySelector('[data-testid="form"]');
    if (!appEmbed && !shadowForm) {
      resolve(false);
      return;
    }

    const initialStep = appEmbed?.getAttribute('data-current-step') ?? 'form';
    let resolved = false;

    const finish = (success) => {
      if (resolved) return;
      resolved = true;
      stepObserver?.disconnect();
      clearTimeout(timeoutId);
      resolve(success);
    };

    const onStepChange = () => {
      const step = appEmbed?.getAttribute('data-current-step');
      if (!step || step === initialStep) return;
      finish(SUCCESS_STEPS.has(step) || step !== 'form');
    };

    const stepObserver = appEmbed
      ? new MutationObserver(onStepChange)
      : null;

    if (stepObserver && appEmbed) {
      stepObserver.observe(appEmbed, { attributes: true, attributeFilter: ['data-current-step'] });
    }

    if (shadowForm) {
      shadowForm.addEventListener('submit', () => finish(true), { once: true });
    }

    const timeoutId = setTimeout(() => {
      const errors = getShadowValidationErrors(shadow);
      finish(errors.length === 0);
    }, 10000);
  });

  const syncToShadowForm = async (gate, shadow) => {
    const billingSameAsShipping = gate.querySelector('[name="billing_same_as_shipping"]')?.checked !== false;

    // Always reveal both the Shopify Forms billing and shipping sections.
    // We mirror values ourselves below instead of relying on the native
    // "same as billing" checkbox, which only ever copies billing into
    // shipping — the opposite of what we need, since the always-visible
    // block on this form is shipping, not billing.
    setShadowCheckbox(shadow, [
      '#same_as_billing_address',
      '[id="same_as_billing_address"]',
      'input[name="same_as_billing_address"]'
    ], false);

    await new Promise((resolve) => setTimeout(resolve, 150));

    const fields = gate.querySelectorAll('[data-shopify-field]');
    const failures = [];

    const syncProvince = async (key, value) => {
      if (setShadowInput(shadow, SHADOW_FIELD_MAP[key], value)) return true;

      const toggle = findDropdownToggle(shadow, SHADOW_DROPDOWN_KEYS[key], SHADOW_LABEL_FALLBACKS[key]);
      if (!toggle) return true; // Forms hides this field for the selected country; nothing to sync.

      if (toggle.hasAttribute('aria-controls')) return setDropdownToggleValue(shadow, toggle, value);

      // The label-fallback search can return a plain field instead of a
      // dropdown button, for countries without formal province/state
      // zones — write straight into it rather than treating it as a
      // failed dropdown lookup.
      if ('value' in toggle) {
        setNativeValue(toggle, value);
        dispatchInputEvents(toggle);
        return true;
      }

      return false;
    };

    for (const field of fields) {
      const key = field.dataset.shopifyField;
      const value = field.value?.trim() ?? '';
      const labelFallback = SHADOW_LABEL_FALLBACKS[key];

      if (key === 'company_name') {
        const synced = setShadowInput(shadow, SHADOW_FIELD_MAP.company_name, value, labelFallback);
        if (!synced && value) failures.push(key);

        // Billing and shipping each have their own recipient field; a
        // shared selector list here would only ever fill the first match.
        setShadowInput(shadow, [
          '#billing_address_recipient',
          '[id="billing_address_recipient"]',
          'input[data-testid="field-billing_address_recipient"]'
        ], value);
        setShadowInput(shadow, [
          '#shipping_address_recipient',
          '[id="shipping_address_recipient"]',
          'input[data-testid="field-shipping_address_recipient"]'
        ], value);
        continue;
      }

      if (key === 'country') {
        const countryLabel = field instanceof HTMLSelectElement
          ? field.selectedOptions?.[0]?.textContent?.trim() || value
          : value;
        const synced = setShadowInput(shadow, SHADOW_FIELD_MAP.country, value, labelFallback);
        if (!synced && value) failures.push(key);

        // Shipping and billing each have their own country selector in
        // Shopify Forms; both need to be set independently, or the
        // block whose country is never touched keeps whatever default
        // it started with, which throws off phone validation and
        // whether province/state is shown for that block.
        if (countryLabel) {
          if (!(await setAddressCountry(shadow, 'shipping_address_country', countryLabel))) failures.push('shipping_country');
          if (!(await setAddressCountry(shadow, 'billing_address_country', countryLabel))) failures.push('billing_country');
        }

        await new Promise((resolve) => setTimeout(resolve, 120));
        continue;
      }

      if (key === 'phone_number') {
        if (!value) continue;

        const countryValue = gate.querySelector('[data-shopify-field="country"]')?.value?.trim();
        const phoneInput =
          findShadowField(shadow, SHADOW_FIELD_MAP.phone_number) ||
          findShadowFieldByLabel(shadow, 'phone');

        if (!phoneInput) {
          failures.push(key);
          continue;
        }

        // Paste an international-format number so the widget auto-detects the
        // country from the dial code and validates it (a plain value-set reverts).
        pasteIntoInput(phoneInput, toInternationalPhone(value, countryValue));
        await new Promise((resolve) => setTimeout(resolve, 60));

        const billingPhoneInput = findShadowField(shadow, [
          '#billing_address_phone',
          '[id="billing_address_phone"]',
          'input[name="billing_address_phone"]',
          'input[data-testid="field-billing_address_phone"]'
        ]);
        if (billingPhoneInput) {
          pasteIntoInput(billingPhoneInput, toInternationalPhone(value, countryValue));
          await new Promise((resolve) => setTimeout(resolve, 60));
        }

        // Shipping has its own phone field too, otherwise it is left with
        // just the country's dial-code prefix once the country dropdown is
        // synced, which Shopify Forms rejects as an invalid number.
        const shippingPhoneInput = findShadowField(shadow, [
          '#shipping_address_phone',
          '[id="shipping_address_phone"]',
          'input[name="shipping_address_phone"]',
          'input[data-testid="field-shipping_address_phone"]'
        ]);
        if (shippingPhoneInput) {
          pasteIntoInput(shippingPhoneInput, toInternationalPhone(value, countryValue));
          await new Promise((resolve) => setTimeout(resolve, 60));
        }
        continue;
      }

      if (key === 'contact_name') {
        const { first, last } = splitName(value);
        const lastField = findShadowField(shadow, [
          '#last_name',
          '[id="last_name"]',
          'input[name="last_name"]',
          'input[data-testid="field-last_name"]'
        ]);

        if (lastField) {
          // Two-field name form (First name + Last name).
          if (!setShadowInput(shadow, ['#first_name'], first)) failures.push('first_name');
          if (!setShadowInput(shadow, ['#last_name'], last)) failures.push('last_name');
        } else {
          // Single "Contact name" field (mapped to first_name) — write the full name.
          if (!setShadowInput(shadow, ['#first_name', 'input[data-testid="field-first_name"]'], value)) {
            failures.push('contact_name');
          }
        }

        setShadowInput(shadow, [
          '#billing_address_first_name',
          '[id="billing_address_first_name"]',
          'input[data-testid="field-billing_address_first_name"]'
        ], first);
        setShadowInput(shadow, [
          '#billing_address_last_name',
          '[id="billing_address_last_name"]',
          'input[data-testid="field-billing_address_last_name"]'
        ], last);

        setShadowInput(shadow, [
          '#shipping_address_first_name',
          '[id="shipping_address_first_name"]',
          'input[data-testid="field-shipping_address_first_name"]'
        ], first);
        setShadowInput(shadow, [
          '#shipping_address_last_name',
          '[id="shipping_address_last_name"]',
          'input[data-testid="field-shipping_address_last_name"]'
        ], last);
        continue;
      }

      if (key === 'business_type') {
        // Forms app may render this as a dropdown OR a plain text input.
        const toggle = findDropdownToggle(shadow, SHADOW_DROPDOWN_KEYS.business_type, labelFallback);
        let synced = false;

        if (toggle && toggle.hasAttribute('aria-controls')) {
          synced = await setShadowDropdown(
            shadow,
            SHADOW_DROPDOWN_KEYS.business_type,
            value,
            labelFallback
          );
        }

        if (!synced) {
          synced = setShadowInput(shadow, SHADOW_FIELD_MAP.business_type, value, labelFallback);
        }

        if (!synced && value) failures.push(key);
        continue;
      }

      if (key === 'shipping_province') {
        const synced = await syncProvince('shipping_province', value);
        if (!synced && value) failures.push(key);

        if (billingSameAsShipping) {
          const billingSynced = await syncProvince('billing_province', value);
          if (!billingSynced && value) failures.push('billing_province');
        }
        continue;
      }

      if (key === 'billing_province') {
        if (billingSameAsShipping) continue; // already mirrored from shipping_province above
        const synced = await syncProvince('billing_province', value);
        if (!synced && value) failures.push(key);
        continue;
      }

      if (key.startsWith('shipping_')) {
        const selectors = SHADOW_FIELD_MAP[key];
        const synced = setShadowInput(shadow, selectors, value, labelFallback);
        if (!synced && value) failures.push(key);

        if (billingSameAsShipping) {
          const billingKey = key.replace('shipping_', 'billing_');
          const billingSelectors = SHADOW_FIELD_MAP[billingKey];
          if (billingSelectors) {
            const billingSynced = setShadowInput(shadow, billingSelectors, value, SHADOW_LABEL_FALLBACKS[billingKey]);
            if (!billingSynced && value) failures.push(billingKey);
          }
        }
        continue;
      }

      if (key.startsWith('billing_')) {
        if (billingSameAsShipping) continue; // already mirrored from the matching shipping_* field above
        const selectors = SHADOW_FIELD_MAP[key];
        if (selectors) {
          const synced = setShadowInput(shadow, selectors, value, labelFallback);
          if (!synced && value) failures.push(key);
        }
        continue;
      }

      const selectors = SHADOW_FIELD_MAP[key];
      if (selectors) {
        const synced = setShadowInput(shadow, selectors, value, labelFallback);
        if (!synced && value) failures.push(key);
      }
    }

    await settleShadowForm();
    return failures;
  };

  const submitShadowForm = (shadow) => {
    const submitButton = shadow.querySelector('[data-testid="btn-form-submit"]');
    if (!submitButton) throw new Error('submit_missing');
    submitButton.click();
  };

  // A `required` control inside a `hidden` container still counts for
  // constraint validation, but the browser cannot focus it to report the
  // error, so `form.reportValidity()` aborts the submit with no visible
  // feedback. Keep each billing field's `required` in sync with its
  // visibility (billing starts hidden when "same as shipping" is checked).
  const setBillingFieldsHidden = (gate, hidden) => {
    gate.querySelectorAll('[data-wholesale-billing-field]').forEach((field) => {
      field.hidden = hidden;
    });

    gate
      .querySelectorAll('[data-wholesale-billing-field] input, [data-wholesale-billing-field] select, [data-wholesale-billing-field] textarea')
      .forEach((input) => {
        if (input.dataset.wholesaleRequired === undefined) {
          input.dataset.wholesaleRequired = String(input.required);
        }
        input.required = hidden ? false : input.dataset.wholesaleRequired === 'true';
      });
  };

  const initWholesaleGateFormSync = (gate) => {
    const form = gate.querySelector('[data-wholesale-gate-form]');
    if (!form || form.dataset.wholesaleGateSyncInit) return;

    form.dataset.wholesaleGateSyncInit = 'true';

    // Billing starts hidden when "same as shipping" is checked (the default),
    // so drop `required` from those hidden fields now — otherwise the initial
    // hidden-but-required fields silently block submission.
    const billingToggle = gate.querySelector('[name="billing_same_as_shipping"]');
    setBillingFieldsHidden(gate, billingToggle ? billingToggle.checked : true);

    const formId = form.dataset.shopifyFormId || gate.dataset.shopifyFormId;

    // Pre-warm the hidden Shopify Forms shadow DOM while the visitor fills in
    // the form, so submission doesn't have to wait for the app embed to load.
    const prewarm = () => {
      if (!formId || gate.wholesaleShadowReady) return;
      gate.wholesaleShadowReady = waitForShadowForm(formId, gate, 20000).catch(() => null);
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(prewarm);
    } else {
      setTimeout(prewarm, 200);
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      hideSyncError(gate);

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!formId) {
        showSyncError(gate, gate.dataset.syncError || 'Form is not configured.');
        return;
      }

      setSubmitting(gate, true);

      try {
        prewarm();
        const shadow = (await gate.wholesaleShadowReady) || (await waitForShadowForm(formId, gate));
        const syncFailures = await syncToShadowForm(gate, shadow);

        if (syncFailures.length) {
          showSyncError(
            gate,
            `${gate.dataset.syncError || 'Submission failed.'} (Could not sync: ${syncFailures.join(', ')})`
          );
          return;
        }

        submitShadowForm(shadow);
        const succeeded = await watchForSuccess(shadow);

        if (succeeded) {
          showSuccess(gate);
        } else {
          const validationErrors = getShadowValidationErrors(shadow);
          const message = validationErrors.length
            ? `${gate.dataset.syncError || ''} (${validationErrors.join(', ')})`
            : gate.dataset.syncError || 'Submission failed. Please try again.';
          showSyncError(gate, message);
        }
      } catch (error) {
        const mount = gate.querySelector('[data-wholesale-gate-forms-mount]');
        const hasEmbed = mount?.querySelector('shopify-forms-embed');
        const message = !hasEmbed
          ? gate.dataset.embedMissingError || gate.dataset.syncError
          : gate.dataset.syncError || 'Submission failed. Please try again.';
        showSyncError(gate, message);
      } finally {
        setSubmitting(gate, false);
      }
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-wholesale-gate-tab]');

    if (tab) {
      const gate = tab.closest('[data-wholesale-gate]');
      if (gate) activateWholesaleGateTab(gate, tab);
    }
  });

  document.addEventListener('keydown', (event) => {
    const currentTab = event.target.closest('[data-wholesale-gate-tab]');
    if (!currentTab) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

    const gate = currentTab.closest('[data-wholesale-gate]');
    if (!gate) return;

    const tabs = Array.from(gate.querySelectorAll('[data-wholesale-gate-tab]'));
    const currentIndex = tabs.indexOf(currentTab);
    const nextIndex = event.key === 'ArrowRight'
      ? (currentIndex + 1) % tabs.length
      : (currentIndex - 1 + tabs.length) % tabs.length;
    const nextTab = tabs[nextIndex];

    if (nextTab) {
      event.preventDefault();
      activateWholesaleGateTab(gate, nextTab);
      nextTab.focus();
    }
  });

  document.addEventListener('change', (event) => {
    const toggle = event.target.closest('[name="billing_same_as_shipping"]');
    if (!toggle) return;

    const gate = toggle.closest('[data-wholesale-gate]');
    if (!gate) return;

    setBillingFieldsHidden(gate, toggle.checked);
  });

  document.querySelectorAll('[data-wholesale-gate]').forEach(initWholesaleGateFormSync);

  document.addEventListener('shopify:section:load', (event) => {
    const gate = event.target.querySelector('[data-wholesale-gate]') ?? event.target.closest?.('[data-wholesale-gate]');
    if (gate) initWholesaleGateFormSync(gate);
  });

  } catch(e) { console.error(e); }
})();
})();
